import React from 'react'
import { connect } from 'react-redux'
import ModalNotification from '../ModalNotification/ModalNotification'
import { _dispatch as dispatch, } from '../../../state/actions'
import { INFO } from '../../../variables'
import { Types } from '../../../state/actionTypes'
import { useTranslation } from 'react-i18next'
import { clearServiceWorkerAndCaches, markServiceWorkerReset } from '../../../serviceWorkerRegistration'

export const clearPersistedUpdateFlag = () => {
  const persistedRoot = window.localStorage.getItem('persist:root')
  if (!persistedRoot) return

  try {
    const parsedRoot = JSON.parse(persistedRoot)
    const utilities = parsedRoot.utilities ? JSON.parse(parsedRoot.utilities) : {}

    window.localStorage.setItem('persist:root', JSON.stringify({
      ...parsedRoot,
      utilities: JSON.stringify({
        ...utilities,
        update: false
      })
    }))
  } catch (error) {
    console.error('[StoreUpdateDetector] Error clearing persisted update flag:', error)
  }
}

function StoreUpdateDetector({ dispatch, update, persistor }) {
  const { t } = useTranslation()

  const onAccept = async () => {
    dispatch({ type: Types.SET_UPDATE, payload: false })
    try {
      if (persistor && persistor.flush) {
        await persistor.flush()
      } else {
        clearPersistedUpdateFlag()
      }
    } catch (error) {
      console.error('[StoreUpdateDetector] Error flushing persisted update flag:', error)
      clearPersistedUpdateFlag()
    } finally {
      markServiceWorkerReset()
      try {
        await clearServiceWorkerAndCaches()
      } catch (error) {
        console.error('[StoreUpdateDetector] Error clearing service worker:', error)
      }
      window.location.reload()
    }
  }

  return (
    <ModalNotification
      open={update}
      title={t('Reload the app and enjoy Corporate Experience improvements')}
      paragraph={t('Reload your app to continue using Corporate Experience. Without the update, unfortunately you will not be able to continue using the app.')}
      type={INFO}
      cancelButton={false}
      onAccept={onAccept}
      acceptLabel={'Recargar'}
    />
  )
}

const mapDispatchToProps = {
  dispatch
}

const mapStateToProps = state => {
  return {
    update: state.utilities.update
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StoreUpdateDetector)
